import type { CategorySection } from "src/http/types";
import { RecommendedForYou } from "src/website-apps/shared/components/recommended-for-you/RecommendedForYou";

interface RecommendedForYouInSearchProps {
  readonly categoryId?: number | undefined;
  readonly hasNoResults: boolean;
  readonly recommendations: Maybe<CategorySection>;
}

export const RecommendedForYouInSearch = ({
  hasNoResults,
  categoryId,
  recommendations,
}: RecommendedForYouInSearchProps) => {
  const { categoryItems } = recommendations ?? {};
  const categoryResults = {
    ...categoryItems,
    items: categoryItems?.items?.map((e) => e) ?? [],
  };

  // Only render if the search did not have any results
  if (!hasNoResults || (categoryItems?.items?.length ?? 0) > 0) {
    return null;
  }

  return (
    <RecommendedForYou
      carouselKey="SearchRecommendedForYouCarousel"
      selectedCarouselGenre={categoryId}
      items={categoryResults}
      size="medium"
    />
  );
};
